/** Angular Imports */
import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Dates } from 'app/core/utils/dates';

/** Custom Services */
import { GroupsService } from 'app/groups/groups.service';
import { SettingsService } from 'app/settings/settings.service';
import { STANDALONE_SHARED_IMPORTS } from 'app/standalone-shared.module';

/**
 * Close Group Component
 */
@Component({
  selector: 'LOSx-close-group',
  templateUrl: './close-group.component.html',
  styleUrls: ['./close-group.component.scss'],
  imports: [
    ...STANDALONE_SHARED_IMPORTS
  ]
})
export class CloseGroupComponent implements OnInit {
  private formBuilder = inject(UntypedFormBuilder);
  private groupsService = inject(GroupsService);
  private dateUtils = inject(Dates);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private settingsService = inject(SettingsService);

  /** Minimum date allowed. */
  minDate = new Date(2000, 0, 1);
  /** Maximum date allowed. */
  maxDate = new Date();
  /** Close Group form. */
  closeGroupForm: UntypedFormGroup;
  /** Group Closure Data */
  closureData: any;
  /** Group Id */
  groupId: any;

  /**
   * @param {FormBuilder} formBuilder Form Builder
   * @param {GroupsService} groupsService Shares Service
   * @param {Dates} dateUtils Date Utils
   * @param {ActivatedRoute} route Activated Route
   * @param {Router} router Router
   * @param {SettingsService} settingsService SettingsService
   */
  constructor() {
    this.route.data.subscribe((data: { groupActionData: any }) => {
      this.closureData = data.groupActionData.closureReasons;
    });
    this.groupId = this.route.parent.snapshot.params['groupId'];
  }

  ngOnInit() {
    this.maxDate = this.settingsService.businessDate;
    this.createCloseGroupForm();
  }

  /**
   * Creates the close group form.
   */
  createCloseGroupForm() {
    this.closeGroupForm = this.formBuilder.group({
      closureDate: [
        '',
        Validators.required
      ],
      closureReasonId: [
        '',
        Validators.required
      ]
    });
  }

  /**
   * Submits the form and closes the group.
   */
  submit() {
    const closeGroupFormData = this.closeGroupForm.value;
    const locale = this.settingsService.language.code;
    const dateFormat = this.settingsService.dateFormat;
    const prevClosedDate: Date = this.closeGroupForm.value.closureDate;
    if (closeGroupFormData.closureDate instanceof Date) {
      closeGroupFormData.closureDate = this.dateUtils.formatDate(prevClosedDate, dateFormat);
    }
    const data = {
      ...closeGroupFormData,
      dateFormat,
      locale
    };
    this.groupsService.executeGroupCommand(this.groupId, 'close', data).subscribe(() => {
      this.router.navigate(['../../'], { relativeTo: this.route });
    });
  }
}
